import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { useAuth } from '../../context/AuthContext';
import { AuthShell } from './Login';

const GoogleBtn = () => {
  const start = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/app';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <Button type="button" onClick={start} variant="outline" data-testid="google-signup-btn"
      className="w-full rounded-full h-11 border-white/15 bg-white/5 hover:bg-white/10">
      <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-4 h-4 mr-2" />
      Continue with Google
    </Button>
  );
};

export default function Signup() {
  const nav = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success('Account created — welcome!');
      nav('/app');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Sign up failed');
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Start creating free">
      <p className="text-slate-400 text-sm mb-6">Already have an account? <Link to="/login" className="text-[#FF884D] hover:text-white">Log in</Link></p>
      <GoogleBtn />
      <div className="flex items-center gap-3 my-5"><div className="h-px bg-white/10 flex-1" /><span className="text-xs text-slate-500 font-mono">OR</span><div className="h-px bg-white/10 flex-1" /></div>
      <form onSubmit={submit} className="space-y-4">
        <div><Label className="text-slate-300">Name</Label>
          <Input data-testid="signup-name" value={name} onChange={(e) => setName(e.target.value)}
            className="mt-1.5 bg-[#12141D] border-white/12 h-11" placeholder="Your name" /></div>
        <div><Label className="text-slate-300">Email</Label>
          <Input data-testid="signup-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1.5 bg-[#12141D] border-white/12 h-11" placeholder="you@channel.com" /></div>
        <div><Label className="text-slate-300">Password</Label>
          <Input data-testid="signup-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="mt-1.5 bg-[#12141D] border-white/12 h-11" placeholder="At least 6 characters" /></div>
        <Button data-testid="signup-submit" type="submit" disabled={busy} className="w-full rounded-full h-11 font-semibold">
          {busy ? 'Creating…' : 'Create free account'}
        </Button>
      </form>
      <p className="text-xs text-slate-500 mt-4">Free plan includes 30 processing minutes. No credit card required.</p>
    </AuthShell>
  );
}
